<script>
  import { formatNoteDate, noteDirection } from '../../pages/mgmt/leadHelpers';

  let { notes = [], colSpan = 6 } = $props();
</script>

<tr class="notes-row">
  <td colspan={colSpan}>
    <div class="notes-panel">
      {#each notes as note (note.id)}
        <article class={`note-entry note-${noteDirection(note.status)}`}>
          <time>{formatNoteDate(note.createdAt)}</time>
          <p>{note.text}</p>
        </article>
      {/each}
    </div>
  </td>
</tr>
